import React from "react";
import { Footer } from "../../component/global/Footer/Footer";
import { Navbar } from "../../component/global/Navbar/Navbar";
import { Herox } from "../../component/non-global/Hero/Hero";
import { Priceing } from "../../component/non-global/Priceing/Priceing";

export const Home = () => {
  return (
    <>
      <Navbar />
      <Herox />
      <Priceing />
      <Footer />
    </>
  );
};
